module.exports = __webpack_public_path__ + "img/12.c7dccaac.jpg";